export default [
	{ label: '전체', category: '' },
	{ label: 'Best', category: 'best' },
	{ label: '글쓰기', category: 'post' },
	{ label: '글보내기', category: 'syndicate' },
	{ label: '꾸미기', category: 'blog' },
	{ label: '관리 및 통계', category: 'admin' },
	{ label: '수익', category: 'ad' },
	{ label: '스팸/불펌 방지', category: 'spamcopyright' },
	{ label: '멀티미디어', category: 'multimedia' },
    { label: 'PC', category: 'pc' },
    { label: '모바일', category: 'mobile' },
]
